import { render, staticRenderFns } from "./costTwos.vue?vue&type=template&id=78283cd2&scoped=true"
import script from "./costTwos.vue?vue&type=script&lang=js"
export * from "./costTwos.vue?vue&type=script&lang=js"
import style0 from "./costTwos.vue?vue&type=style&index=0&id=78283cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78283cd2",
  null
  
)

export default component.exports